import { render, staticRenderFns } from "./Reklamation.vue?vue&type=template&id=065a36b4&scoped=true&"
import script from "./Reklamation.vue?vue&type=script&lang=js&"
export * from "./Reklamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a36b4",
  null
  
)

export default component.exports